import { useState, useRef, useEffect } from "react";
import axiosInstance from "../../API/interceptor";
import PersonRaciPopup from "./PersonRaciPopup";


const photoCache     = {};
const photoListeners = {};

export function PhotoAvatar({ name, userId, size = 24 }) {
  const [src, setSrc] = useState(
    typeof photoCache[userId] === "string" &&
    photoCache[userId] !== "loading" &&
    photoCache[userId] !== "none"
      ? photoCache[userId] : null
  );

  useEffect(() => {
    if (!userId) return;
    if (
      typeof photoCache[userId] === "string" &&
      photoCache[userId] !== "loading" &&
      photoCache[userId] !== "none"
    ) { setSrc(photoCache[userId]); return; }

    if (!photoListeners[userId]) photoListeners[userId] = new Set();
    photoListeners[userId].add(setSrc);
    if (photoCache[userId] === "loading") return;

    photoCache[userId] = "loading";
    axiosInstance.get(`/task_assignment/get_user_photo/${userId}`)
      .then(res => {
        if (res.data?.success && res.data?.photo) {
          photoCache[userId] = res.data.photo;
          photoListeners[userId]?.forEach(fn => fn(res.data.photo));
        } else {
          photoCache[userId] = "none";
        }
      })
      .catch(() => { photoCache[userId] = "none"; });

    return () => { photoListeners[userId]?.delete(setSrc); };
  }, [userId]);

  const colors = ["#6366F1","#8B5CF6","#EC4899","#F59E0B","#10B981","#3B82F6"];
  const bg = colors[(name || "").charCodeAt(0) % colors.length];

  if (src && src !== "loading" && src !== "none") {
    return (
      <img src={src} alt={name}
        className="rounded-full object-cover shrink-0 border-2 border-white"
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div className="rounded-full shrink-0 flex items-center justify-center border-2 border-white text-white font-bold"
      style={{ width: size, height: size, background: bg, fontSize: Math.round(size * 0.38) }}>
      {(name || "?").slice(0, 2).toUpperCase()}
    </div>
  );
}

export default function PersonCell({ name, personId, idx, size = 24 }) {
  const [visible, setVisible] = useState(false);
  const [rect,    setRect]    = useState(null);
  const ref       = useRef();
  const hideTimer = useRef(null);
  const openTimer = useRef(null);

  const cancelHide   = () => clearTimeout(hideTimer.current);
  const scheduleHide = () => {
    clearTimeout(openTimer.current);
    hideTimer.current = setTimeout(() => setVisible(false), 500);
  };
  const handleEnter  = () => {
    cancelHide();
    clearTimeout(openTimer.current);
    if (ref.current) {
      const nextRect = ref.current.getBoundingClientRect();
      openTimer.current = setTimeout(() => {
        setRect(nextRect);
        setVisible(true);
      }, 500);
    }
  };

  if (!name) return <span className="text-[12px] text-[#9CA3AF]">—</span>;

  return (
    <div ref={ref} className="flex items-center gap-1.5 cursor-pointer"
      onMouseEnter={handleEnter} onMouseLeave={scheduleHide}>
      <PhotoAvatar name={name} userId={personId} size={size}/>
      <span className="block text-[12px] text-[#374151] whitespace-nowrap overflow-hidden text-ellipsis min-w-0 max-w-[90px]">
        {name.split(" ")[0]}
      </span>
      {visible && rect && (
        <PersonRaciPopup name={name} personId={personId} anchorRect={rect} cancelHide={cancelHide} scheduleHide={scheduleHide}/>
      )}
    </div>
  );
}